import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectActivitiesSuppressIllustrations } from '@store/member-activities/member-activities.selectors';

@Component({
  selector: 'app-activity-error-page',
  templateUrl: './activity-error-page.component.html',
})
export class ActivityErrorPageComponent implements OnInit {
  @Input() errorLocation: 'dashboard' | 'activity' = 'dashboard';

  public suppressIllustrations: Observable<boolean>;
  public errorMap = {
    dashboard: {
      cta: 'activity_error_cta_dashboard',
      redirectPath: '/',
    },
    activity: {
      cta: 'activity_error_cta_activity',
      redirectPath: '/activities',
    },
  };

  constructor(private router: Router, private store: Store<any>) {}

  ngOnInit() {
    this.suppressIllustrations = this.store.select(
      selectActivitiesSuppressIllustrations
    );
  }

  get config() {
    return this.errorMap[this.errorLocation];
  }

  public handleRedirect() {
    this.router.navigate([this.config.redirectPath], {
      queryParamsHandling: 'preserve',
    });
  }
}
